import { buildVehiclePath, VehicleModel } from 'client/data/models/vehicle-v2';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';

export const anchorItemDataProvider = WrappedComponent =>
  connectToModel(WrappedComponent, {
    vehicle: bindToPath(({ componentParams }) => {
      const { make, model, year } = componentParams;

      return buildVehiclePath({ make: make.value, model: model.value, year });
    }, VehicleModel),
  });
